import React, { useEffect } from "react";
import HomeReviews from "../../components/homepage-components/HomeReviews";
import Faq from "../../components/universal-components/Faq";
import Hero from "../../components/Hero";
import Intro from "../../components/Intro";
import ContentLeft from "../../components/ContentLeft";
import ContentRight from "../../components/ContentRight";
import CallToAction from "../../components/CallToAction";
import { prContent } from "../../page-content/commercial-content/pr-content";

const PrivateRental = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Hero data={prContent} />
      <Intro data={prContent} />
      <ContentLeft data={prContent} />
      <ContentRight data={prContent} />
      <CallToAction data={prContent} />
      <HomeReviews />
      <Faq />
    </>
  );
};

export default PrivateRental;
